import { render } from "./spaceModelList.vue?vue&type=template&id=f71866b0&scoped=true&ts=true"
import script from "./spaceModelList.vue?vue&type=script&lang=ts"
export * from "./spaceModelList.vue?vue&type=script&lang=ts"

import "./spaceModelList.vue?vue&type=style&index=0&id=f71866b0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f71866b0"]])

export default __exports__